module.exports = __webpack_public_path__ + "static/f20b07e4bf1108d689dde5c413f27dab472629b619b3d060c38f43cec2878551-855e950ce2b0d16c2b2316e0615d1f34.png";